#ifdef USE_TANGENT

varying vec3 vn;
varying vec4 vt;

#endif
